export default __webpack_public_path__ + "static/media/zoom-in.c0b56d65.svg";